import { forwardRef } from 'react';

import { TableCell, TableCellProps } from '@material-ui/core';

import { IdentityFragment } from '@spotify/plugin-confidence-iam-react';

interface OwnerCellProps extends TableCellProps {
  owner: Pick<IdentityFragment, 'displayName'> | undefined | null;
}

export const OwnerCell = forwardRef<HTMLTableCellElement, OwnerCellProps>(
  ({ owner, ...props }, ref) => {
    return (
      <TableCell {...props} ref={ref}>
        {owner?.displayName ?? 'unknown'}
      </TableCell>
    );
  },
);
OwnerCell.displayName = 'OwnerCell';
